import { AlertController } from '@ionic/angular/standalone';
import { _ } from '@ngx-translate/core';
import { TranslateService } from '../services/translate.service';

export class AlertUtils {
    private static alertCtrl: AlertController;
    private static translate: TranslateService;

    static init(alertCtrl: AlertController, translate: TranslateService) {
        this.alertCtrl = alertCtrl;
        this.translate = translate;
    }

    static async showSuccess(message: string) {
        if (!this.alertCtrl) {
            return;
        }

        const alert = await this.alertCtrl.create({
            message: this.translate.get(message),
            buttons: [
                {
                    text: this.translate.get(_('Continue')),
                    role: 'ok',
                },
            ],
        });

        return await alert.present();
    }

    static async showError(message: string) {
        if (!this.alertCtrl) {
            return;
        }

        const alert = await this.alertCtrl.create({
            message: this.translate.get(message),
            buttons: [
                {
                    text: this.translate.get(_('Continue')),
                    role: 'ok',
                },
            ],
        });

        return await alert.present();
    }

    static async askConfirmation(message: string): Promise<boolean> {
        return new Promise(async (resolve) => {
            if (!this.alertCtrl) {
                return;
            }

            const alert = await this.alertCtrl.create({
                message: this.translate.get(message),
                buttons: [
                    {
                        text: this.translate.get(_('Cancel')),
                        role: 'cancel',
                        handler: () => resolve(false),
                    },
                    {
                        text: this.translate.get(_('Continue')),
                        role: 'ok',
                        handler: () => resolve(true),
                    },
                ],
            });

            return await alert.present();
        });
    }
}
